import state from "./state"

const cartModalEl = document.querySelector(".cart-modal")
const contentContainerEl = document.querySelector(".cart-modal .content-container")
const itemsEl = contentContainerEl.querySelector(".items")
const emptyCartTextWrapperEl = document.querySelector(".cart-modal .empty-cart-text-wrapper")
const cartCountNumber = document.querySelector(".cart .count-number")
const addToCartBtnEl = document.querySelector(".add-to-cart-btn")

const itemTemplate = document.querySelector("#cart-item-template")


function makeElVisible(el) {
    el.dataset.hidden = "false"
}

function makeElInvisible(el) {
    el.dataset.hidden = "true"
}

addToCartBtnEl.addEventListener("click", () => {
    state.addCartItem(state.currentSelected)
    state.setCurrentSelected(1)
})

state.addCartItemsChangedCallback((items) => {
    function handleNewItemAdded() {
        // only one type is availabe so no iterating
        const cartItem = items[0];

        itemsEl.textContent = ""

        const itemEL = itemTemplate.content.cloneNode(true)

        const thumbnailImgEl = itemEL.querySelector(".thumbnail")
        const itemNameEl = itemEL.querySelector(".item-name")
        const basePriceEl = itemEL.querySelector(".base-price")
        const itemNumberEl = itemEL.querySelector(".item-number")
        const totalPriceEl = itemEL.querySelector(".total-price")
        const deleteBtnEl = itemEL.querySelector(".delete-item-btn")

        thumbnailImgEl.src = `images/${cartItem.thumbnail}`
        thumbnailImgEl.alt = "cart item thumbnail"
        itemNameEl.textContent = cartItem.name
        basePriceEl.textContent = '$' + cartItem.price
        itemNumberEl.textContent = cartItem.count
        totalPriceEl.textContent = '$' + cartItem.totalPrice
        deleteBtnEl.addEventListener("click", () => {
            state.removeCartItem()
        })

        itemsEl.append(itemEL)

        makeElInvisible(emptyCartTextWrapperEl)
        makeElVisible(contentContainerEl)
        makeElVisible(cartModalEl)
        makeElVisible(cartCountNumber)

        cartCountNumber.textContent = cartItem.count
    }

    function handleEmptyCart() {
        makeElInvisible(contentContainerEl)
        makeElInvisible(cartCountNumber)
        makeElVisible(emptyCartTextWrapperEl)
    }

    if (items.length !== 0)
        handleNewItemAdded()
    else
        handleEmptyCart()

})

makeElVisible(emptyCartTextWrapperEl)


